import { useEffect } from 'react';
import { getSessionIdentity, getTokenFromStoredUser } from '@helpers/auth';

const sessionIdentity = (storedUser: string | null): string => getSessionIdentity(getTokenFromStoredUser(storedUser));

export const useSessionSync = (): void => {
    useEffect(() => {
        const onStorage = (event: StorageEvent) => {
            if (event.key === 'user' && sessionIdentity(event.oldValue) !== sessionIdentity(event.newValue)) {
                window.location.reload();
            }
        };
        window.addEventListener('storage', onStorage);
        return () => window.removeEventListener('storage', onStorage);
    }, []);
};
